import React from "react"
import Typography from "aldoo-ra/Typography"
import Button from "aldoo-ra/Button"
import { navigate } from "vike/client/router"

const NotFoundPage = () => {
  return (
    <div className="min-h-screen bg-gradient_bottom_page flex items-center justify-center px-4">
      <div className="text-center">
        <Typography variant="h1" className="mb-6">
          404
        </Typography>
        <Typography variant="h3" className="mb-4">
          Page Not Found
        </Typography>
        <Typography variant="body1" className="mb-8 text-text_secondary">
          The page you're looking for doesn't exist.
        </Typography>
        <Button 
          variant="primary_l" 
          onClick={() => navigate("/")}
        >
          Go Home
        </Button>
      </div>
    </div>
  )
}

export default NotFoundPage